
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"9","r":"9","fill":"#3F51B5"}}),_c('path',{attrs:{"d":"M9 2.333A6.666 6.666 0 112.333 9h1.334a5.334 5.334 0 10.923-3h1.744v1.333h-4v-4h1.333V5A6.654 6.654 0 019 2.333zm.667 3.334v3.056l2.162 2.162-.944.944-2.551-2.554V5.667h1.333z","fill":"#FFF"}})])
          )
        }
      }
    